import {Button, Typography} from '@yandex-delivery/blocks'
import {Drawer, DrawerSection} from '@yandex-delivery/blocks/legacy'
import React from 'react'

import {Validator} from '../Validator'
import {VerticalTimeline} from '../VerticalTimeline'
import {classes} from './ModalMobile.classes'
import type {TimelineDetailsModalProps} from './types'

export const ModalMobile: React.FC<TimelineDetailsModalProps> = ({action, onClose}) => {
  const handleShare = () => {
    if (action.share_button?.action && action.share_button.action.type === 'share') {
      const shareAction = action.share_button.action
      if ('sharing_url' in shareAction) {
        // Простой fallback для шаринга через Web Share API
        if (navigator.share) {
          navigator
            .share({
              title: shareAction.title || '',
              url: shareAction.sharing_url,
            })
            .catch(() => {
              // Игнорируем ошибки (пользователь отменил шаринг)
            })
        }
      }
    }
  }

  return (
    <Drawer onClose={onClose}>
      <DrawerSection>
        {/* Заголовок + Validator (аналогично Android VerticalTimelineHeader) */}
        <div className={classes.header}>
          <Typography thickness="bold" variant="title4">
            {action.title}
          </Typography>

          {/* Validator - блок со статусом (аналог Validator из Figma) */}
          {action.bubble && (
            <div className={classes.validator}>
              <Validator bubble={action.bubble} currentPointIndex={0} pointCount={0} />
            </div>
          )}
        </div>

        {/* Вертикальный таймлайн */}
        <div className={classes.content}>
          <VerticalTimeline action={action} />
        </div>

        {/* Футер с кнопками */}
        <div className={classes.footer}>
          {action.share_button && (
            <Button className={classes.shareButton} onPress={handleShare} size="l" variant="default">
              <Typography variant="body2">{action.share_button.text}</Typography>
            </Button>
          )}
          <Button className={classes.doneButton} onPress={onClose} size="l" variant="action">
            <Typography thickness="medium" variant="body2">
              {action.done_button.text}
            </Typography>
          </Button>
        </div>
      </DrawerSection>
    </Drawer>
  )
}
